import { Avatar, Grid } from "@mui/material";
import { MxJiraCustomComponentProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import { AutoCompleteItemOption } from "@rf-l1/form/selects/MxAutoCompleteField/MxAutoCompleteField";

import MxImageBlur from "@rf-l1/images/MxImageBlur";
import MxTypography from "@rf-l1/MxTypography";
import { agentAutoCompleteItem } from "@rf/adapters/autocomplete-items/agentItemAdapters";

export const MxCustomAgentItem = (
  props: MxJiraCustomComponentProps<agentAutoCompleteItem>
) => {
  const { item, ...rest } = props;
  return (
    <AutoCompleteItemOption {...rest}>
      <Grid
        container
        alignItems="center"
        spacing={1}
        sx={{
          filter: item?.extraData?.agentData.isSuspend ? "grayscale(100%)" : "none"
        }}
      >
        <Grid item xs="auto">
          <MxImageBlur
            src={item.extraData?.agentData.picture}
            width={30}
            height={30}
            objectFit="cover"
            borderRadius={30}
            alt={item.extraData?.agentData.name}
          />
        </Grid>

        <Grid container item flex={1} rowSpacing={0.1}>
          <Grid item xs={12} color="grey.600">
            <MxTypography variant="overline" fontWeight={600}>
              {item.extraData?.agentData.name}
            </MxTypography>
          </Grid>
          <Grid item xs={12}>
            <MxTypography variant="overline" color="grey.600" fontWeight={400}>
              {item.extraData?.agentData.agencyName}
            </MxTypography>
          </Grid>
        </Grid>
      </Grid>
    </AutoCompleteItemOption>
  );
};
